<template lang="">
    <div class="table-responsive">
            <v-row no-gutters>
                <v-dialog v-model="dialog" max-width="600px">
      <v-card v-if="editando">
        <v-card-title>
          <span>Editando <b> {{editando.variable}}</b></span>
        </v-card-title>
        <v-card-text>
          <!-- Campo de entrada con v-model -->
          <v-text-field v-model="editando.edited_value" label="Nuevo valor"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray darken-1" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveChanges">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                
             
            
                <v-col v-for="(datosTrata,index) in datosTratadosComputados" :key="index"  :md="clase">
                    <table class="table table-striped table-hover"> 
                        <tbody>
                            <tr v-for="(item, index) in datosTrata" :key="item.id">
                                <td :class="clase_vigilancia" v-if="item.tipo=='VIGILAR'"> {{ item.variable }}</td>
                                <td v-else> {{ item.variable }}</td>
                                <td v-if="item.tipo=='BOOLEAN'"><img width=32 height=32 :src="tieneAlarma(item.valor)"/></td>
                                <td v-if="item.tipo=='REAL'">{{ item.valor }}</td>
                                <td v-if="item.tipo=='TRIESTADO'"><img width=32 height=32 :src="triestado(item.valor)"/></td>
                                <td v-if="item.tipo=='ESCRITURA_BOOL'">
                                    <v-btn @click="escribir(item.topic_escritura)">W</v-btn>
                                </td>
                                <td v-if="item.tipo=='ESCRITURA_REAL'">
                                    {{item.valor}}
                                    <v-icon small @click.stop="startEditing(item)">mdi-pencil</v-icon>
                                </td>

                                <td :class="clase_vigilancia" v-if="item.tipo=='VIGILAR'">{{ item.valor }}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-col>
            </v-row>       
        <!-- {{datosTratadosComputados}} -->
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        datosTratados: Array,
        client: Object
    },methods: {
        closeDialog() {
        // Cierra el diálogo y resetea el valor de editando
        this.dialog = false;
        this.editando = null; // Resetear editando a null cuando se cierra
        },
        saveChanges() {
        // Maneja el guardado de cambios
            if (this.editando) {
                console.log('Valor guardado:', this.editando.edited_value);
                this.client.publish(this.editando.topic_escritura, this.editando.edited_value);
            }
            this.editando=null;
            this.closeDialog();
        },
        startEditing(item){
         console.log(item)
         this.editando=item;
         this.editando.edited_value=this.editando.valor;
         this.dialog=true;
        },
        escribir(topic_in){

            console.log("quiere escribir en topic", topic)
            console.log(this.client)
            let publish = {
                topic: topic_in,
                qos: 0,
                payload: '{ "msg": "Hello, I am browser." }',
            }


            const { topic, qos,payload } = publish

            this.client.publish(topic, payload, [qos], error => {
                if (error) {
                    console.log('Publish error', error)
                }
            });
        },
        tieneAlarma(i){
             return (i)? require("@/assets/rojo.png"):require("@/assets/verde.png");
        },
        triestado(v){
            console.log(`el valor esz  ${v}`)
            let f='';
            switch (v) {
                case 1:
                    f=require("@/assets/verde.png");
                    break;
                case 2:
                    f=require("@/assets/azul.png");
                    break;
                case 3:
                    f=require("@/assets/rojo.png");
                    break;
            
                default:
                    break;
            }
            return f;
        }
    },
    data() {
        return {
            division: 13,
            editando: null,
            dialog: false,
        }
    },

    computed: {
        ...mapState(['potencia_inmovil']),
        clase_vigilancia(){
            return  this.potencia_inmovil?'con_alarma':'sin_alarma'
        },
        modulo11(){
            return Math.ceil(this.datosTratados.length/this.division)
        },
        clase() {
            const r = this.division/this.modulo11
            // return (this.datosTratados.length>this.division)?'6':'12'
            return r.toString()
        },
        datosTratadosComputados(){
            //numero de columnas
            const numColumnas = this.modulo11;


            let resultado=[]
            for(let i=0;i<numColumnas;i++)resultado.push([])
            let indice = 0;
            this.datosTratados.forEach((element, index)  => {
                if(index==this.editando){
                    element.isEditing=true;
                }
                resultado[indice].push(element)
                indice++
                if(indice==numColumnas)indice=0
            });
            // for (let index = 0; index < this.modulo11; index++) {
            //     resultado.push(this.datosTratados.slice(index*this.division,(index+1)*this.division))
            // }
            // resultado.push(this.datosTratados.slice(this.division+1,this.datosTratados.length))
            return resultado
        }
    },
    
}
</script>
<style scoped>
    .con_alarma{
        color: red;
    }

    .sin_alarma{
        color: black;
    }
</style>